import React from "react";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/upcomingsupply.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class UpcomingSupply extends React.Component {
  static contextType = FilterContext;

  state = {
    sumOfChargeableArea: 0,
    noOfComplexes: 0,
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_upcoming_supply", BodyAsFormData(filters))
      .then((res) => {
        this.setState({
          sumOfChargeableArea: res.data.sum_of_chargeable_area,
          noOfComplexes: res.data.no_of_complxes,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_upcoming_supply",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            sumOfChargeableArea: res.data.sum_of_chargeable_area,
            noOfComplexes: res.data.no_of_complxes,
          });
        });
    }
  }

  render() {
    return (
      <div className="newWidgetClass">
        <img
          alt="upcoming Supply Icon"
          src="/edge/images/updated_logos/upcomingsupply.svg"
          className="imgWidth100"
        />
        <div className="colorGreen">
          <h2>
            {this.state.sumOfChargeableArea} msf{" "}
            <span>({this.state.noOfComplexes} assets)</span>
          </h2>
          <p>Upcoming Supply - 36 months</p>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(UpcomingSupply);
